import styled from '@emotion/styled';
import { IIllustratedText } from '../../types/@types/generated/contentful';
import BuildingBlockInfo from '../component-library/layout/BuildingBlockInfo';
import HighlightSectionBleedLayout from '../component-library/layout/HighlightSection/HighlightSectionBleedLayout';
import SectionBackground from '../component-library/SectionBackground';
import Image, { ImageStyleProps } from './Image';
import { PageSectionComponent } from './pageSections';
import RichText from './RichText';
import sectionToCompatibleProps from './util/sectionToCompatibleProps';

const FullImage = styled.div`
  height: 100%;
  width: 100%;
  > div {
    width: 100%;
    height: 100%;
  }
`;

const StyledImage = styled(Image)<{ imageFit?: string }>`
  object-fit: ${(props) => props.imageFit || 'cover'};
  width: 100%;
  height: 100%;
`;

const HighlightSectionBleed: PageSectionComponent<null> = ({ section }) => {
  const { references, settings, buildingBlock } = section.fields;
  const {
    id,
    title,
    description,
    reversed,
    media: { image },
    button: { label, prompt, href, colorContext },
    backgroundColor,
  } = sectionToCompatibleProps({ section });

  const imageFit = settings?.imageFit;
  const bullets = buildingBlock?.fields.bullets || ((references as unknown) as IIllustratedText[]);

  return (
    <SectionBackground id={id} backgroundColor={backgroundColor}>
      <HighlightSectionBleedLayout
        reverseColumns={reversed}
        content={
          <BuildingBlockInfo
            title={<RichText document={title} />}
            description={<RichText document={description} />}
            buttonLabel={label}
            buttonPrompt={prompt}
            buttonColor={colorContext}
            href={href}
            Logo={
              (bullets &&
                bullets.length === 1 &&
                ((props: ImageStyleProps) => (
                  <Image
                    asset={((bullets as unknown) as IIllustratedText[])[0].fields.image}
                    {...props}
                  />
                ))) ||
              undefined
            }
          />
        }
        media={
          <FullImage>
            <StyledImage asset={image} imageFit={imageFit} />
          </FullImage>
        }
      />
    </SectionBackground>
  );
};

export default HighlightSectionBleed;
